var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { FieldLabel } from './field-label';
import { formFieldId } from '../utils/form-field-id';
export var FieldContainerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    font-family: ", ";\n    font-size: ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    font-family: ", ";\n    font-size: ", ";\n\n    ", "\n  "])), theme.UNIT(8), theme.FONT('app'), theme.FONT_SIZE_FOR('base', 'normal'), function (props) {
    return props.marginless && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  })
});
var FieldLabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    user-select: none;\n    font-family: ", ";\n    padding-bottom: ", ";\n    padding-left: 2px;\n  "], ["\n    user-select: none;\n    font-family: ", ";\n    padding-bottom: ", ";\n    padding-left: 2px;\n  "])), theme.FONT('app'), theme.UNIT(3))
});
var ErrorStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: ", ";\n    padding-left: 2px;\n    font-size: ", ";\n    font-weight: 500;\n    padding-left: ", ";\n    color: ", ";\n  "], ["\n    padding-top: ", ";\n    padding-left: 2px;\n    font-size: ", ";\n    font-weight: 500;\n    padding-left: ", ";\n    color: ", ";\n  "])), theme.UNIT(3), theme.FONT_SIZE(15), theme.UNIT(1), theme.COLOR('error'))
});
var BGStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background-position: bottom left;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background-position: bottom left;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  FieldLabel: styled(FieldLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FieldLabelStyles),
  BG: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BGStyles),
  Error: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ErrorStyles)
};
export var FieldContainer = function (props) {
  var className = props.className,
    field = props.field,
    children = props.children;
  var label = field.label,
    errorMessage = field.errorMessage;
  return React.createElement(My.Container, {
    name: formFieldId(field),
    className: className
  }, label && React.createElement(My.FieldLabel, {
    field: field
  }), React.createElement(My.BG, null, children), errorMessage && React.createElement(My.Error, null, errorMessage));
};
FieldContainer.defaultProps = FieldContainerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;